module.exports = __webpack_public_path__ + "img/down_logo.270429f3.png";